export type MonacoTheme = 'vs' | 'vs-dark' | 'noDiffHighlight';

export const MONACO_LANGUAGES = ['json', 'pgsql', 'python', 'sql'] as const;
export type MonacoLanguage = (typeof MONACO_LANGUAGES)[number];
